"use strict";

exports.__esModule = true;
exports.Connection = void 0;
const DEFAULT_OUTPUT_TYPE = 'unknown';
const Connection = exports.Connection = {
  make: ({
    properties = {},
    data = {},
    behaviors = {}
  } = {}) => ({
    properties,
    data,
    behaviors
  }),
  makePropertyConnectionToField: ({
    fieldKey,
    format,
    outputType = DEFAULT_OUTPUT_TYPE
  }) => ({
    type: 'field',
    fieldKey,
    format,
    outputType
  }),
  makePropertyConnectionToReferencedField: ({
    fieldKey,
    referencedFieldKey,
    format,
    outputType = DEFAULT_OUTPUT_TYPE
  }) => ({
    type: 'referencedField',
    fieldKey,
    referencedFieldKey,
    format,
    outputType
  }),
  makePropertyConnectionToExpression: ({
    expression,
    outputType = DEFAULT_OUTPUT_TYPE
  }) => ({
    type: 'expression',
    expression,
    outputType
  }),
  makePropertyConnectionToDatasetMetadata: ({
    datasetMetadataKey,
    outputType = DEFAULT_OUTPUT_TYPE
  }) => ({
    type: 'datasetMetadata',
    datasetMetadataKey,
    outputType
  })
};
//# sourceMappingURL=connection.js.map